import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    padding: {
      xs: '1rem',
      sm: '2rem',
    },
  },
});

export default useSx;
